<template>
  <v-card flat color="rgb(243, 245, 248, .4)" rounded>
    <v-card-title class="d-flex justify-space-between align-center mb-3">
      <h3 class="titleText--text">Dummy Variables</h3>
      <v-btn icon color="blue" title="Create New  Dummy Variables">
        <v-icon
          @click="showAdddilog()"
          >mdi-plus-circle</v-icon
        >
      </v-btn>
    </v-card-title>
          <v-card-text>
            <div class="table-wrapper" style="width: 100%; overflow-x: scroll;" >
              <v-simple-table
                fixed-header
                height="600"
                v-if="dummyVarListcount > 0"
              >
                <template v-slot:default>
                  <thead>
                    <tr class="text-center">
                      <th
                        class="text-center font-weight-bold titleText--text"
                        v-for="(item, key) in dummyVarList.dummy_data[0]"
                        :key="key"
                        style="background: rgb(243, 245, 248)"
                      >
                        <span>
                          {{ key }}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="text-center"
                      v-for="mmdata in dummyVarList.dummy_data"
                      :key="mmdata.id"
                    >
                      <td
                        v-for="(item, key, index) in mmdata"
                        class="text-center"
                        :class="index === 0 ? 'titleText--text font-weight-bold' : 'darkGrey--text'"
                        :key="key"
                        style="background: rgb(243, 245, 248, .4)"
                      >
                      <div :style="{width: index === 1 ? '100px' : ''}">
                        <span>{{ item }}</span>
                      </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
              </v-card-text>

    <v-dialog v-model="dialog" persistent  scrollable width="800">
      <v-card width="800">
        <v-card-title>
          <h4 class="titleText--text">Dummy Variable ({{this.dummyname}})</h4>
          <v-spacer />
          <v-btn color="titleText" icon @click="closeForm()"> <v-icon>mdi-close</v-icon> </v-btn>
        </v-card-title>
        <v-card-text class="px-0">
          <v-text-field
          v-model="search"
          label="Search"
          style="border-radius: 8px; border: 2px solid #f3f5f8;"
          dense
          color="titleText"
          solo
          flat
          hide-details="auto"
          full-width
          class="mt-3 mx-3"
        />
        <v-data-table
          :headers="headers"
          :items="this.dummyVarListforAdd"
          :search="search"
          disable-pagination
          :hide-default-footer="true"
          class="mt-5 mx-0"
        >
          <template v-slot:header="{ item }">
            <span class="titleText--text">{{item}}</span>
          </template>
          <template v-slot:item.Dummy="{ item }">
            <div class="d-flex justify-end">
              <v-text-field          
                v-model="item.Dummy"
                solo
                flat
                dense
                hide-details="auto"
                background-color="#F3F5F8"
                style="width: 5px; text-align: right;"
                type="number"
                >
              </v-text-field>
            </div>
          </template>
          <template v-slot:item.region="{item}">
            <span class="titleText--text">{{item.region}}</span>
          </template>
          <template v-slot:item.date="{item}">
            <span class="darkGrey--text">{{item.date}}</span>
          </template>
        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!valid"
            class="my-2 mr-2"
            color="blue"
            depressed
            dark
            height="36"
            width="120"
            @click="addupdatedummyvariable()"
          >
            <span class="text-capitalize font-weight-bold">Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import apifactory from "../api";
import globalclass from "../../../global/globalvar";
export default {
  data: () => ({
    stepidCurrent: globalclass.PARAM_Step_MDP_DVC,
    stepidPrevious: globalclass.PARAM_Step_MDP_AS,
    currentprojectid: "0",
    currentloginuser: "9",
    prevstepQueryStringParm: [],
    prevstepQueryStringParmUrlnew: [],

    dummyVarList: [],
    dummyVarListforAdd: [],
    dummyVarListforAddNew: [],
    dummyVarRegions: [],
    dummyVarListcount: 0,
    dummyname: "",
    search: "",

    valid: true,
    dialog: false,
    txtvarname: "",
    selectedvarid: 0,
    nextdummyvar: 1,
    tempcount: 1,
    variablelistSelected: [],

    // group grid
    headers: [
      { 
        text: "Region", 
        value: "region", 
        align: "center", 
        class: "titleText--text" 
      },
      {
        text: "Date",
        align: "center",
        value: "date",
        class: "titleText--text"
      },
      { 
        text: "Dummy", 
        value: "Dummy", 
        align: "center",
        class: "titleText--text",
      },
    ],
  }),
  methods: {
    IsNumber(event) {
      //if (!/\d/.test(event.key) && event.key !== ".")
      //return event.preventDefault();
      if (event.key != 1 && event.key != -1) return event.preventDefault();
    },
    isColumnforHide(varkey) {
      let result = 0;
      if (varkey == "id") {
        result = 1;
      }
      if (varkey == "region_date") {
        result = 1;
      }
      if (varkey == "varvalue") {
        result = 1;
      }
      return result;
    },
    isColumnforNonEdit(varkey) {
      let result = 1;
      if (varkey == "date") {
        result = 0;
      }
      if (varkey == "id") {
        result = 0;
      }
      if (varkey == "region_date") {
        result = 0;
      }
      if (varkey == "varvalue") {
        result = 0;
      }
      if (varkey == "region") {
        result = 0;
      }

      return result;
    },
    AddMoreDummy() {
      this.tempcount = this.tempcount + 1;
      let newvarname = "d" + this.tempcount + "_dummy";
      let tempdata = this.dummyVarList;
      for (var i = 0; i < tempdata.length; i++) {
        let obj = new Object();
        obj = tempdata[i];
        obj[newvarname] = "";
        this.dummyVarListforAddNew.push(obj);
      }
    },
    closeForm() {
      this.getalldummyvariables();
      this.dialog = false;
    },
    addupdatedummyvariable() {
      for (let index = 0; index < this.dummyVarRegions.length; index++) {
        let filterdata = [];
        filterdata = this.dummyVarListforAdd.filter(
          (a) => a.region == this.dummyVarRegions[index] && a.Dummy != "0"
        );

        if (filterdata.length > 0) {
          // alert("var_name" + this.dummyname);
          let filterdatafortype1 = [];
          let filterdatafortypeminus1 = [];
          filterdatafortype1 = filterdata.filter((a) => a.Dummy === "1");
          //alert(JSON.stringify(filterdatafortype1));
          filterdatafortypeminus1 = filterdata.filter((a) => a.Dummy === "-1");

          let vvar_name = this.dummyname;
          let vregion = filterdata[0].region;
          if (filterdatafortype1.length > 0) {
            this.calladd_dummy_var_forOne(
              filterdatafortype1,
              vregion,
              vvar_name,
              "1"
            );
          }
          if (filterdatafortypeminus1.length > 0) {
            this.calladd_dummy_var_forOne(
              filterdatafortypeminus1,
              vregion,
              vvar_name,
              "-1"
            );
          }
        }
      }
      this.closeForm()
    },

    calladd_dummy_var_forOne(vitemlist, vregion, vvarname, vtype) {
      let templistvardata = [];
      for (let element in vitemlist) {
        // alert(filterdata[element].date);

        templistvardata.push(vitemlist[element].date);
      }
      this.callapiadd_dummy_var(vvarname, JSON.stringify(templistvardata),vregion,vtype);
    },
       callapiadd_dummy_var(vvarname,vparam,vregion,vtype) {
      this.prevstepQueryStringParm = "";

      apifactory.call_save_dummy_var(vvarname, vparam, vregion, vtype)
    },
    filterfinalsavevariables() {},
    showAdddilog() {
      //this.getParametrOfPrvStep();
      //alert(this.prevstepQueryStringParmUrlnew);
      this.dialog = true;
      this.getalldummyvariablesListforAdd();
    },
    gettheprojectid() {
      this.currentprojectid = apifactory.getcurrentproject();
    },
    update(objdata, event, varkey) {
      // alert(event);
      //alert(JSON.stringify(objdata));
      let tempobj = objdata;
      //alert(tempobj.id);
      //alert(varkey);
      let vid = tempobj.id;
      // alert(vid);
      for (var i = 0; i < this.dummyVarListforAdd.length; i++) {
        if (this.dummyVarListforAdd[i].id === vid) {
          //alert( this.dummyVarListforAdd[i][varkey]);
          //this.dummyVarListforAdd[i].d1_dummy = event;

          this.dummyVarListforAdd[i][varkey] = event;
          break;
        }
      }
    },
    getalldummyvariables() {
      this.dummyVarList = [];
      apifactory
        .dummyvariables_getall()
        .then((res) => {
          if (res.status != 200) {
            this.dummyVarList = [];
            // alert(this.processdataitems.length);
          } else {
            //alert(res.data.status);
            if (res.data.status == "204") {
              this.dummyVarList = [];
            } else {
              this.dummyVarList = res.data;
              let count = 0;
              for (var key in this.dummyVarList[0])
                if (this.dummyVarList[0].hasOwnProperty(key)) {
                  count++;
                }
              this.nextdummyvar = count - 2 + 1;
              this.dummyVarListcount = 1;
            }
            //alert(datacount);
            //this.dummyVarList = res.data;
            //alert(this.dummyVarList.length);
            /*let count = 0;
                        for (var key in this.dummyVarList[0])
                            if (this.dummyVarList[0].hasOwnProperty(key)) {
                                count++;
                            }
                        this.nextdummyvar = (count - 2) + 1;
*/
          }
          //alert(this.itemVariablename.length);
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getalldummyvariablesListforAdd() {
      this.dummyVarListforAdd = [];
      //alert(this.prevstepQueryStringParmUrlnew);
      // alert( this.nextdummyvar);
      //this.nextdummyvar = 1;
      apifactory
        .dummyvariables_AddNewDummyVarForUI()
        .then((res) => {
          if (res.status != 200) {
            this.dummyVarListforAdd = [];
            // alert(this.processdataitems.length);
          } else {
            //this.dummyVarListforAdd = res.data.decay_output;

            this.listfind_decay = [];

            let index = 0;
            for (let element in res.data.decay_output) {
              res.data.decay_output[element].id = index + 1;
              res.data.decay_output[element].varvalue = false;
              //varvalue

              this.listfind_decay.push(res.data.decay_output[element]);
              index = index + 1;
            }

            this.dummyVarListforAdd = res.data.decay_output;
            this.dummyname = res.data.dummy_name;
            let templist = [];
            for (let element in res.data.decay_output) {
              templist.push(res.data.decay_output[element].region);
            }
            let unique = [...new Set(templist)];
            this.dummyVarRegions = unique;
          }
          //alert(this.itemVariablename.length);
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";

      apifactory
        .gettheParameterByProjectStep(this.stepidPrevious)
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
            // alert(this.processdataitems.length);
          } else {
            this.prevstepQueryStringParm = res.data;

            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
                // alert( this.prevstepQueryStringParm[k]);
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrlnew = strurl;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
  mounted() {
    this.gettheprojectid();
    this.getalldummyvariables();
    this.getParametrOfPrvStep();
  },
  computed: {
    classnamefortable(index) {
      let classname = "text-left";
      if (index === 1) {
        classname = "header10";
      }
      if (index === 2) {
        classname = "header20";
      }
      return classname;
    },
  },
};
</script>

<style>
.txtnew {
  width: 40px !important;
}

.divtablecontent {
  width: 80px !important;
  text-align: center;
  align-content: center;
}

.header20 {
  width: 150px !important;
}

.header10 {
  width: 10px !important;
}

.redcolr {
  background-color: blue;
}
thead tr {
  background: #f1f1f1 !important
}
</style>
